<template>
  <header>
    <div class="logo">
      Pudding-Cuite
    </div>
    <nav>
      <ul>
        <!-- href 是真实路径（history 路由）：点击走 router.go，中键/右键「在新标签打开」也能直达 -->
        <li><a href="/" :class="{ active: appState.page === 'home' }" @click="go('/', $event)">Home</a></li>
        <li><a href="/taskblock" :class="{ active: appState.page === 'taskblock' }" @click="go('/taskblock', $event)">TaskBlock</a></li>
        <li><a href="/about" @click="go('/about', $event)">About</a></li>
      </ul>
    </nav>
    <div class="search-box">
      <input type="text" placeholder="Search">
    </div>
  </header>
</template>

<script>
import router from '@/router'

export default {
  name: 'MyNav',
  inject: ['appState'],
  methods: {
    go(path, e) {
      e.preventDefault()
      router.go(path)
    }
  }
}
</script>

<style scoped>
header{
  display:flex;
  justify-content:space-between;
  align-items:center;
}
.logo{
  font-weight:800;
  font-size:1.625rem;
  letter-spacing:1px;
  color:var(--dark-brown);
}

nav ul{
  list-style:none;
  display:flex;
  align-items:center;
  gap:2.125rem;
}
nav a{
  text-decoration:none;
  color:var(--dark-brown);
  font-size:1.1375rem;
  font-weight:600;
  opacity:0.85;
}
nav a.active{opacity:1;}
.search-box{
  display:flex;
  align-items:center;
  gap:0.375rem;
  border-bottom:0.063rem solid #c9b8a8;
  padding-bottom:0.125rem;
}
.search-box input{
  border:none;
  background:transparent;
  outline:none;
  font-size:1.056rem;
  color:#8a7a6c;
  width:80px;
  font-family:inherit;
}

@media (max-width:800px){
  nav ul{gap:1rem;}
}
</style>
